export default "__VITE_ASSET__C07LxI_V__"